import {SET_ATTACH_WALL_IDENTITY} from '../actionType';

export default function (state = {}, action) {
    switch (action.type) {
        case SET_ATTACH_WALL_IDENTITY:
            return {
                ...state,
                wallIdentity: action.wallIdentity,
            };
        default:
            return state;
    }
}
